import React from "react";
import { Link } from "gatsby";
import Search from "../Search/Search";
import FilterDropDown from "./FilterDropDown";
import getData from "../../../services/utils";
import "../../../styles/filterBar.less";

const DesktopFilter = ({ vertical, resourcesLink, market, placeholder }) => {
    const data = getData(market, vertical);

    const sections = data.sections || [];

    const dropDowns = sections.map((section) => (
        <FilterDropDown
            key={section.title}
            btnText={`Browse by ${section.title}`}
            links={section.sublevels}
            resourcesLink={resourcesLink}
        />
    ));

    const noDropDowns =
        data.noDropDowns &&
        data.noDropDowns.map((link) => (
            <Link key={link.title} className="filter" to={`${resourcesLink}${link.url_slug}/`}>
                {link.title}
            </Link>
        ));

    return (
        <div className="filterBar">
            <Search vertical={vertical} market={market} resourcesLink={resourcesLink} placeholder={placeholder} />
            {dropDowns}
            {noDropDowns}
        </div>
    );
};

export default DesktopFilter;
